export const USE_SINGLE_COMPANY_PARTNER_QUERY_KEY = "useSingleCompanyPartnerQuery";
export const USE_COMPANY_PARTNER_COLLECTION_QUERY_KEY = "useCompanyPartnerCollectionQuery";
